import { schema } from 'normalizr'

// Circular Dependencies - Use the define method
// const item = new schema.Entity('item')
// const child = new schema.Entity('child')
// item.define({ children: [child] })

// Define Entities
const activityLogType = new schema.Entity('activityLogTypes')
const asset = new schema.Entity('assets')
const assetComment = new schema.Entity('assetComments')
const assetCommentType = new schema.Entity('assetCommentTypes')
const assetType = new schema.Entity('assetTypes')
const blockedServiceJob = new schema.Entity('blockedServiceJobs')
const blockout = new schema.Entity('blockouts')
const capacity = new schema.Entity('capacities')
const client = new schema.Entity('clients')
const clientV4 = new schema.Entity('clientsV4')
const clientYoutubeChannel = new schema.Entity('clientYoutubeChannels')
const emailReplacement = new schema.Entity('emailReplacements')
const fileServiceContainer = new schema.Entity('fileServiceContainers')
const filter = new schema.Entity('filters')
const image = new schema.Entity('images')
const notificationType = new schema.Entity('notificationTypes')
const providerV4 = new schema.Entity('providersV4')
const resource = new schema.Entity('resources')
const resourceType = new schema.Entity('resourceTypes')
const service = new schema.Entity('services')
const serviceCategory = new schema.Entity('serviceCategories')
const serviceGroup = new schema.Entity('serviceGroups')
const serviceJob = new schema.Entity('serviceJobs')
const serviceJobChecklistItem = new schema.Entity('serviceJobChecklistItems')
const serviceJobChecklistItemType = new schema.Entity('serviceJobChecklistItemTypes')
const serviceJobClientDetail = new schema.Entity('serviceJobClientDetails', {}, {
  idAttribute: (value) => value.serviceJobId,
})
const serviceJobDetail = new schema.Entity('serviceJobDetails')
const serviceJobHistory = new schema.Entity('serviceJobHistories')
const serviceJobNote = new schema.Entity('serviceJobNotes')
const serviceJobStatus = new schema.Entity('serviceJobStatuses')
const serviceJobTag = new schema.Entity('serviceJobTags')
const serviceJobUser = new schema.Entity('serviceJobUsers')
const serviceJobUserRole = new schema.Entity('serviceJobUserRoles')
const serviceJobUserTime = new schema.Entity('serviceJobUserTimes')
const statistic = new schema.Entity('statistics')
const timetracker = new schema.Entity('timetrackers')
const user = new schema.Entity('users')
const userRole = new schema.Entity('userRoles')
const userV4 = new schema.Entity('usersV4')
const vsirStatus = new schema.Entity('vsirStatuses')
const wordReplacement = new schema.Entity('wordReplacements')
const workflow = new schema.Entity('workflows')
const youtubeChannel = new schema.Entity('youtubeChannels')
const zone = new schema.Entity('zones')
const zoneV4 = new schema.Entity('zonesV4')

asset.define({
  comments: [assetComment],
})

serviceCategory.define({
  services: [service],
})

serviceGroup.define({
  services: [service],
})

serviceJob.define({
  details: [serviceJobDetail],
  histories: [serviceJobHistory],
  notes: [serviceJobNote],
  postProductionChecklistItems: [serviceJobChecklistItem],
  tags: [serviceJobTag],
  users: [serviceJobUser],
})

timetracker.define({
  serviceJobUserTimes: [serviceJobUserTime],
})

// Export Schemas
export const Schemas = {
  ACTIVITY_LOG_TYPE: activityLogType,
  ACTIVITY_LOG_TYPE_ARRAY: [activityLogType],
  ASSET: asset,
  ASSET_ARRAY: [asset],
  ASSET_COMMENT: assetComment,
  ASSET_COMMENT_ARRAY: [assetComment],
  ASSET_COMMENT_TYPE: assetCommentType,
  ASSET_COMMENT_TYPE_ARRAY: [assetCommentType],
  ASSET_TYPE: assetType,
  ASSET_TYPE_ARRAY: [assetType],
  BLOCKED_SERVICE_JOB_TYPE: blockedServiceJob,
  BLOCKED_SERVICE_JOB_TYPE_ARRAY: [blockedServiceJob],
  BLOCKOUT: blockout,
  BLOCKOUT_ARRAY: [blockout],
  CAPACITY: capacity,
  CAPACITY_ARRAY: [capacity],
  CLIENT: client,
  CLIENTV4: clientV4,
  CLIENTV4_ARRAY: [clientV4],
  CLIENT_ARRAY: [client],
  CLIENT_YOUTUBE_CHANNEL: clientYoutubeChannel,
  CLIENT_YOUTUBE_CHANNEL_ARRAY: [clientYoutubeChannel],
  EMAIL_REPLACEMENT: emailReplacement,
  EMAIL_REPLACEMENT_ARRAY: [emailReplacement],
  FILTER: filter,
  FILTER_ARRAY: [filter],
  FILE_SERVICE_CONTAINER: fileServiceContainer,
  IMAGE: image,
  IMAGE_ARRAY: [image],
  NOTIFICATION_TYPE: notificationType,
  NOTIFICATION_TYPE_ARRAY: [notificationType],
  PROVIDERV4: providerV4,
  PROVIDERV4_ARRAY: [providerV4],
  RESOURCE: resource,
  RESOURCE_ARRAY: [resource],
  RESOURCE_TYPE: resourceType,
  RESOURCE_TYPE_ARRAY: [resourceType],
  SERVICE: service,
  SERVICE_ARRAY: [service],
  SERVICE_CATEGORY: serviceCategory,
  SERVICE_CATEGORY_ARRAY: [serviceCategory],
  SERVICE_GROUP: serviceGroup,
  SERVICE_GROUP_ARRAY: [serviceGroup],
  SERVICE_JOB: serviceJob,
  SERVICE_JOB_ARRAY: [serviceJob],
  SERVICE_JOB_CHECKLIST_ITEM: serviceJobChecklistItem,
  SERVICE_JOB_CHECKLIST_ITEM_ARRAY: [serviceJobChecklistItem],
  SERVICE_JOB_CHECKLIST_ITEM_TYPE: serviceJobChecklistItemType,
  SERVICE_JOB_CHECKLIST_ITEM_TYPE_ARRAY: [serviceJobChecklistItemType],
  SERVICE_JOB_CLIENT_DETAIL: serviceJobClientDetail,
  SERVICE_JOB_CLIENT_DETAIL_ARRAY: [serviceJobClientDetail],
  SERVICE_JOB_DETAIL: serviceJobDetail,
  SERVICE_JOB_DETAIL_ARRAY: [serviceJobDetail],
  SERVICE_JOB_HISTORY: serviceJobHistory,
  SERVICE_JOB_HISTORY_ARRAY: [serviceJobHistory],
  SERVICE_JOB_NOTE: serviceJobNote,
  SERVICE_JOB_NOTE_ARRAY: [serviceJobNote],
  SERVICE_JOB_STATUS: serviceJobStatus,
  SERVICE_JOB_STATUS_ARRAY: [serviceJobStatus],
  SERVICE_JOB_TAG: serviceJobTag,
  SERVICE_JOB_TAG_ARRAY: [serviceJobTag],
  SERVICE_JOB_USER: serviceJobUser,
  SERVICE_JOB_USER_ARRAY: [serviceJobUser],
  SERVICE_JOB_USER_ROLE: serviceJobUserRole,
  SERVICE_JOB_USER_ROLE_ARRAY: [serviceJobUserRole],
  SERVICE_JOB_USER_TIME: serviceJobUserTime,
  SERVICE_JOB_USER_TIME_ARRAY: [serviceJobUserTime],
  STATISTIC: statistic,
  STATISTIC_ARRAY: [statistic],
  TIMETRACKER: timetracker,
  TIMETRACKER_ARRAY: [timetracker],
  USER: user,
  USERV4: userV4,
  USERV4_ARRAY: [userV4],
  USER_ARRAY: [user],
  USER_ROLE: userRole,
  USER_ROLE_ARRAY: [userRole],
  VSIR_STATUS: vsirStatus,
  VSIR_STATUS_ARRAY: [vsirStatus],
  WORD_REPLACEMENT: wordReplacement,
  WORD_REPLACEMENT_ARRAY: [wordReplacement],
  WORKFLOW: workflow,
  YOUTUBE_CHANNEL: youtubeChannel,
  YOUTUBE_CHANNEL_ARRAY: [youtubeChannel],
  ZONE: zone,
  ZONEV4: zoneV4,
  ZONEV4_ARRAY: [zoneV4],
  ZONE_ARRAY: [zone],
}

export default Schemas
